import { render } from "./TwoFactorSection.vue?vue&type=template&id=2ea13da3&scoped=true"
import script from "./TwoFactorSection.vue?vue&type=script&lang=js"
export * from "./TwoFactorSection.vue?vue&type=script&lang=js"

import "./TwoFactorSection.vue?vue&type=style&index=0&id=2ea13da3&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea13da3"]])

export default __exports__